import { Abacus } from "core/Abacus.Core";

var down = window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart";
var move = window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove";
var up = window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend";

$.event.special.outerClick = {
  setup: function(data, namespaces, eventHandle) {},

  teardown: function(namespaces) {},

  add: function(handleObj) {
    var self = this,
      touched = false;

    this._handler = function(e) {
      var $target = $(e.target);
      var $parents = $target.parents();
      var elementIsAncestor = $parents.filter(function() {
        return this === self;
      }).length;

      if (!touched) {
        if (elementIsAncestor) {
          touched = true;
        }
      } else {
        if (!elementIsAncestor) {
          touched = false;
          handleObj.handler.apply(this, arguments);
        }
      }
    };

    $(document).on(down, this._handler);
  }
};

$.event.special.touchClick = {
  delegateType: down,
  bindType: down,

  handle: function(e) {
    var ret,
      target = this,
      related = e.relatedTarget,
      handleObj = e.handleObj,
      arg = arguments,
      moved = false,
      startX = e.originalEvent.changedTouches[0].clientX,
      startY = e.originalEvent.changedTouches[0].clientY,
      moveHandler,
      upHandler;

    var moveHandler = function(e) {
      var touchobj = e.originalEvent.changedTouches[0];
      var distX = parseInt(touchobj.clientX) - startX;
      var distY = parseInt(touchobj.clientY) - startY;
      if (distX || distY) moved = true;
    };

    var upHandler = function() {
      $(target)
        .off(move, moveHandler)
        .off(up, upHandler);
      if (!moved) handleObj.handler.apply(target, arg);
    };

    $(target).on(move, moveHandler);

    $(target).on(up, upHandler);

    return this;
  }
};



// WEBPACK FOOTER //
// ./Javascript/jquery/EventHelpers/EventHelpers.js